import React, { useState, useEffect } from 'react';
import '../App.css';

// 👇 Añadimos isOpen y onClose como propiedades
function Alerts({ isOpen, onClose }) {
    const url = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    
    const [logs, setLogs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const formatTacticalDate = (isoString) => {
        const date = new Date(isoString);
        if (isNaN(date)) return "---";
        const day = (0 + date.getDate().toString()).slice(-2);
        const month = (0 + (date.getMonth() + 1).toString()).slice(-2);
        const year = date.getFullYear().toString().slice(-2);
        const hours = (0 + date.getHours().toString()).slice(-2);
        const minutes = (0 + date.getMinutes().toString()).slice(-2);
        const seconds = (0 + date.getSeconds().toString()).slice(-2);
        return `${day}/${month}/${year} [${hours}:${minutes}:${seconds}]`;
    };

    async function fetchLogs() {
        if (!isOpen) return; // Si el panel está cerrado, no gastamos internet
        
        try {
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token
                },
            }
            let response = await fetch(url + '/logs', options);
            if (response.ok) {
                const dataReceived = await response.json();
                setLogs(dataReceived);
            }
        } catch (err) {
            console.error("Error obteniendo logs:", err);
        } finally {
            setIsLoading(false);
        }
    }

    // Efecto para recargar los datos cuando se abre el panel
    useEffect(() => {
        if (isOpen) fetchLogs();
        const timer = setInterval(() => {
            if (isOpen) fetchLogs();
        }, 30000);
        return () => clearInterval(timer);
    }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    const filteredLogs = logs.filter(log => {
        const searchLower = searchTerm.toLowerCase();
        return (
            (log.message && log.message.toLowerCase().includes(searchLower)) ||
            (log.ident && log.ident.toLowerCase().includes(searchLower)) ||
            (log.category && log.category.toLowerCase().includes(searchLower)) ||
            (log.level && log.level.toLowerCase().includes(searchLower))
        );
    });

    return (
        // 👇 Se le añade la clase 'open' dinámicamente
        <div className={`alerts-page-wrapper ${isOpen ? 'open' : ''}`}>
            
            <div className="alerts-header">
                <h1 className="alerts-title">
                    <i className="fa-solid fa-triangle-exclamation"></i> SYSTEM LOGS
                </h1>
                {/* Botón de cerrar X */}
                <button className="btn-close-alerts" onClick={onClose}>
                    <i className="fa-solid fa-xmark"></i>
                </button>
                <input 
                    type="text" 
                    className="alerts-search-input" 
                    placeholder="Search logs..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            {isLoading ? (
                <div style={{ textAlign: 'center', marginTop: '50px', color: '#888' }}>CARGANDO REGISTROS...</div>
            ) : (
                <div className="logs-grid">
                    {filteredLogs.length > 0 ? (
                        filteredLogs.map((log, index) => (
                            <div key={index} className={`log-card mini-log-card level-${log.level}`}>
                                <div className="log-card-header">
                                    <span className="log-date">{formatTacticalDate(log.dateTime)}</span>
                                    <span className={`log-badge ${log.level}`}>{log.level}</span>
                                </div>
                                <div className="log-message">{log.message || "No message detailed."}</div>
                                <div className="log-footer">
                                    <span className="log-meta"><i className="fa-solid fa-microchip" style={{marginRight: '5px'}}></i>{log.ident || "---"}</span>
                                    <span className="log-meta"><i className="fa-solid fa-folder-tree" style={{marginRight: '5px'}}></i>{log.category || "GENERAL"}</span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', color: '#888', marginTop: '20px' }}>No hay registros.</div>
                    )}
                </div>
            )}
        </div>
    );
}

export default Alerts;